import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, CheckCircle } from 'lucide-react';
import axios from 'axios';
import '../styles/landing.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (!sessionId) { setStatus('error'); return; }
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API_URL}/api/payments/status/${sessionId}`);
        if (data.payment_status === 'paid') setStatus('paid');
        else setTimeout(poll, 2000);
      } catch { setStatus('error'); }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="landing-page" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', maxWidth: '600px', padding: '2rem' }}>
        {status === 'loading' && (
          <>
            <div className="display-large" style={{ marginBottom: '1rem' }}>Confirming your prebook...</div>
            <p className="body-large" style={{ color: 'rgba(255,255,255,0.7)' }}>Please wait while we verify your payment.</p>
          </>
        )}
        {status === 'paid' && (
          <>
            <CheckCircle size={80} style={{ color: 'var(--accent)', marginBottom: '1.5rem' }} />
            <div className="display-large" style={{ marginBottom: '1rem' }}>You're In!</div>
            <p className="body-large" style={{ color: 'rgba(255,255,255,0.85)', marginBottom: '2rem' }}>
              Your $20 prebook deposit for the ECLAT GROVE™ R-Series has been confirmed. You'll be among the first to secure your watch when we launch on Kickstarter.
            </p>
            <a href="/">
              <Button className="btn-primary btn-large">
                Back to Home <ArrowRight className="ml-2" size={20} />
              </Button>
            </a>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="display-large" style={{ marginBottom: '1rem' }}>Something went wrong</div>
            <p className="body-large" style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '2rem' }}>
              We couldn't verify your payment. If you were charged, please contact us and we'll sort it out.
            </p>
            <a href="/">
              <Button className="btn-primary btn-large">Back to Home</Button>
            </a>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
